import PropTypes from 'prop-types';
import usePermission from '../../hooks/use-permission';

// Renders its children only when the signed-in user's group holds the permission.
// A render prop is supported for callers that need the answer rather than the gate.
const HasPermission = ({ resource, action, children, fallback }) => {
  const granted = usePermission(resource, action);

  if (typeof children === 'function') return children(granted);

  return granted ? children : fallback;
};

HasPermission.propTypes = {
  resource: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  fallback: PropTypes.node
};

HasPermission.defaultProps = {
  children: null,
  fallback: null
};

export default HasPermission;
